// eslint-disable-next-line @typescript-eslint/ban-ts-comment
import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from '@angular/core';
import { Store, select } from '@ngrx/store';
import * as fromCustomer from '@kanzi-apes/kanzi-customer';
import { Observable, Subject } from 'rxjs';
import { CustomerModel } from '@kanzi-apes/kanzi-models';
import { SafeResourceUrl } from '@angular/platform-browser';
import { EnvironmentService } from '@kanzi-apes/kanzi-utils';
import { KanziAnalyticsReportsService } from '../../services/kanzi-analytics-reports.service';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import {
  createEmbeddingContext,
  EmbeddingContext,
} from 'amazon-quicksight-embedding-sdk';

@Component({
    selector: 'kanzi-apes-kanzi-analytics-report',
    templateUrl: './kanzi-analytics-report.component.html',
    styleUrls: ['./kanzi-analytics-report.component.sass'],
    standalone: false
})
export class KanziAnalyticsReportComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('dashboard') embeddingContainer!: ElementRef;
  private unsubscribe$ = new Subject<void>();
  customerSelected$: Observable<CustomerModel | null> = this.store.pipe(
    select(fromCustomer.getCustomerSelected)
  );
  reportUrl!: SafeResourceUrl;
  reportName = signal<string | null>(null);
  viewLoaded = signal<boolean>(false);
  isWMSEnvironment = this.envService.wmsEnvironment ? true : false;
  tenantId = this.isWMSEnvironment
    ? this.envService.wmsEnvironment?.tenantId || ''
    : this.envService.environment?.tenantId || '';

  reportNameEffects = effect(
    () => {
      if (this.reportName() && this.viewLoaded()) {
        this.analyticsReportService
          .getEmbedReport(
            this.tenantId,
            this.reportName(),
            this.isWMSEnvironment
          )
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((dashBoard) => {
            if (dashBoard.Status == 200) {
              this.dashboard(dashBoard.EmbedUrl);
            }
          });
      }
    },
    { allowSignalWrites: true }
  );

  constructor(
    private store: Store<fromCustomer.State>,
    private analyticsReportService: KanziAnalyticsReportsService,
    private envService: EnvironmentService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((query) => {
      if (query) {
        this.reportName.set(query['reportName']);
      }
    });
  }

  ngAfterViewInit(): void {
    this.viewLoaded.set(true);
  }

  async dashboard(embeddedURL: string) {
    this.embeddingContainer.nativeElement.innerHTML = '';
    const options = {
      url: embeddedURL,
      container: this.embeddingContainer.nativeElement,
      scrolling: 'no',
      height: '1000',
      iframeResizeOnSheetChange: false,
      width: '100%',
      locale: 'es-ES',
      footerPaddingEnabled: true,
      printEnabled: true,
      defaultEmbeddingVisualType: 'TABLE',
    };

    const embeddingContext: EmbeddingContext = await createEmbeddingContext();
    embeddingContext.embedDashboard(options);
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
